<template>
	<div id="page">
		<nav class="colorlib-nav" role="navigation">
      <MobileMenu/>
			<div class="top-menu">
                
				<div class="container">
					<div class="d-flex justify-content-between flex-wrap">
						<div class="col-md-4_">
							<div id="colorlib-logo">
                <router-link 
                  :to="{ name: 'home'}"
                  tag="div"
                >
                  <img class="logo-top" src="@/assets/img/logo.png" alt="Logo ProcessFlex" width="100%">
                  <!-- <div class="slogan">
                    {{ $t('message.slogan') }}
                  </div> -->
                </router-link>
              </div>
						</div>

						<div 
              class="col-md-8_ text-right top-block-right d-flex justify-content-end align-items-center"
            >
							<ul class="main-menu">
								<li class="active_">
                  <router-link :to="{ name: 'home'}">Home</router-link>
                </li>
								<li class="has-dropdown">
									<a href="#">{{ $tc('feature', 2) }}</a>
									<ul class="dropdown">
										<li>
                      <router-link 
                        tag="a" 
                        :to="{ name: 'features'}"
                      >
                        {{ $t('process_management') }}
                      </router-link>
                    </li>
										<li>
                      <router-link 
                        tag="a" 
                        :to="{ name: 'tasks'}"
                      >
                        {{ $tc('task', 2) }}
                      </router-link>
                    </li>
										<li>
                      <router-link 
                        tag="a" 
                        :to="{ name: 'quotation'}"
                      >
                      {{ $t('quotation_and_purchase') }}
                      </router-link>
                    </li>
										<li>
                      <router-link 
                        tag="a" 
                        :to="{ name: 'features/recruitment'}"
                      >
                        {{ $tc('recruitment', 1) }}
                      </router-link>
                    </li>
										<!-- <li>
                      <router-link 
                        tag="a" 
                        :to="{ name: 'features/financial'}"
                      >
                        {{ $t('financial.label') }}
                      </router-link>
                    </li> -->
										<!-- <li>
                      <router-link 
                        tag="a" 
                        :to="{ name: 'features/quotation'}"
                      >
                        {{ $tc('quotation', 2) }}
                      </router-link>
                    </li> -->
									</ul>
								</li>
								<li class="has-dropdown">
                  <router-link :to="{ name: 'resumes'}">{{ $tc('cv', 2) }}</router-link>
									<!-- <ul class="dropdown">
										<li>
                      <router-link 
                        tag="a" 
                        :to="{ name: 'candidate'}"
                      >
                        {{ $tc('candidate', 1) }}
                      </router-link>
                    </li>
										<li>
                      <router-link 
                        tag="a" 
                        :to="{ name: 'features/recruitment'}"
                      >
                        {{ $tc('company', 1) }}
                      </router-link>
                    </li>
									</ul> -->
                </li>
								<li>
                  <router-link :to="{ name: 'plans'}">{{ $tc('plan.label', 2) }}</router-link>
                </li>
								<!-- <li>
                  <router-link :to="{ name: 'contact'}">{{ $tc('contact.label', 1) }}</router-link>
                </li> -->
								<li>
                  <router-link :to="{ name: 'create_account'}">{{ $tc('action.register', 2) }}</router-link>
                </li>
								<li><a :href="urlLogin" target="_blank">{{ $tc('login.label', 2) }}</a></li>
								<!-- <li><a href="about.html">About</a></li>
								<li><a href="shop.html">Shop</a></li>-->
							</ul>
              <TranslateSelect class="d-none d-md-block"/>
						</div>
					</div>
				</div>
			</div>
		</nav>
    <!-- @/assets/images/mobile-1.jpg   -->
     <!-- <img alt="Vue logo" src="@/assets/images/mobile-1.jpg"> -->

    <router-view class="main-container"></router-view>

		<footer id="colorlib-footer">
			<div class="container">
				<div class="row d-flex justify-content-between">
					<!-- <div class="col-md-3 colorlib-widget">
						<h4>About unapp</h4>
						<p>Far from the countries Vokalia and Consonantia, there live the blind texts. Separated they live in Bookmarksgrove right at the coast of the Semantics</p>
						<p>
							<ul class="colorlib-social-icons">
								<li><a href="#"><i class="icon-twitter"></i></a></li>
								<li><a href="#"><i class="icon-facebook"></i></a></li>
								<li><a href="#"><i class="icon-linkedin"></i></a></li>
								<li><a href="#"><i class="icon-dribbble"></i></a></li>
							</ul>
						</p>
					</div> -->
					<div class="col-md-5 colorlib-widget">
						<p>
							<ul class="colorlib-footer-links">
                <li><router-link :to="{ name: 'home'}">Home</router-link></li>
                <li><router-link :to="{ name: 'features'}">{{ $tc('feature', 2) }}</router-link></li>
                <li><router-link :to="{ name: 'tasks'}">{{ $tc('task', 2) }}</router-link></li>
                <li><router-link :to="{ name: 'quotation'}">{{ $t('quotation_and_purchase') }}</router-link></li>
                <li><router-link :to="{ name: 'features/recruitment'}">{{ $tc('recruitment', 1) }}</router-link></li>
                <li><router-link :to="{ name: 'resumes'}">{{ $tc('cv', 2) }}</router-link></li>
                <li><router-link :to="{ name: 'plans'}">{{ $tc('plan.label', 2) }}</router-link></li>
                <li><router-link :to="{ name: 'contact'}">{{ $tc('contact.label', 1) }}</router-link></li>
                <li><router-link :to="{ name: 'create_account'}">{{ $tc('action.create_account', 1) }}</router-link></li>
                <li>
                  <a :href="urlLogin" target="_blank">
                    Login
                  </a>
                </li>
							</ul>
						</p>
					</div>
					<!-- <div class="col-md-4 colorlib-widget text-right">
						<p>
							<ul class="colorlib-footer-links">
                <li>
                  <a @click.prevent="setLang">
                    {{ $tc('language_set.english') }}
                  </a>
                </li>
                <li>
                  <a href="https://processflex.com/#/home?lang=pt" @click="location.reload()">
                    {{ $tc('language_set.portuguese') }}
                  </a>
                </li>
                <li>
                  <a href="https://processflex.com/#/home?lang=pt_br" @click="location.reload()">
                    {{ $tc('language_set.portuguese_br') }}
                  </a>
                </li>
							</ul>
						</p>
					</div> -->
          <!-- <div class="col-md-2 colorlib-widget">
            <a href='https://www.capterra.com/reviews/204777/ProcessFlex?utm_source=vendor&utm_medium=badge&utm_campaign=capterra_reviews_badge'>  <img border='0' src='https://assets.capterra.com/badge/d698f13a8ce69830e6e2c6f1f8ee6333.png?v=2146680&p=204777' /></a>
          </div>  -->
          <!-- <div class="col-md-3 colorlib-widget"> -->
						<!-- <h4>Recent Blog</h4>
						<div class="f-blog">
							<a href="blog.html" class="blog-img" style="background-image: url(@/assets/images/blog-1.jpg);">
							</a>
							<div class="desc">
								<h2><a href="blog.html">Photoshoot Technique</a></h2>
								<p class="admin"><span>30 March 2018</span></p>
							</div>
						</div>
						<div class="f-blog">
							<a href="blog.html" class="blog-img" style="background-image: url(@/assets/images/blog-2.jpg);">
							</a>
							<div class="desc">
								<h2><a href="blog.html">Camera Lens Shoot</a></h2>
								<p class="admin"><span>30 March 2018</span></p>
							</div>
						</div>
						<div class="f-blog">
							<a href="blog.html" class="blog-img" style="background-image: url(@/assets/images/blog-3.jpg);">
							</a>
							<div class="desc">
								<h2><a href="blog.html">Imahe the biggest photography studio</a></h2>
								<p class="admin"><span>30 March 2018</span></p>
							</div>
						</div> -->
					<!-- </div> -->

					<div class="col-md-3 colorlib-widget">
						<!-- <h4>Contact Info</h4> -->
						<ul class="colorlib-footer-links">
							<!-- <li>291 South 21th Street, <br> Suite 721 New York NY 10016</li> -->
							<!-- <li><a href="tel://1234567920"><i class="icon-phone"></i> + 1235 2355 98</a></li> -->
							<li>
                <a href="mailto:info@yoursite.com"><i class="icon-envelope"></i>
                  support@processflex.com
                </a>
              </li>
							<!-- <li><a href="#"><i class="icon-location4"></i> yourwebsite.com</a></li> -->
						</ul>
					</div>
				</div>
			</div>
			<div class="copy">
				<div class="container">
					<div class="row">
						<div class="col-md-12 text-center">
							<p>
								<!-- Link back to Colorlib can't be removed. Template is licensed under CC BY 3.0. -->
                <!-- Copyright &copy;<script>document.write(new Date().getFullYear());</script> All rights reserved | This template is made with <i class="icon-heart" aria-hidden="true"></i> by <a href="https://colorlib.com" target="_blank">Colorlib</a> -->
                <!-- Link back to Colorlib can't be removed. Template is licensed under CC BY 3.0. --><br> 
								<!-- Demo Images: <a href="http://unsplash.co/" target="_blank">Unsplash</a>, <a href="http://pexels.com/" target="_blank">Pexels</a> -->
							</p>
						</div>
					</div>
				</div>
			</div>
		</footer>
	</div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import MobileMenu from "@/components/Layout/MobileMenu";
import TranslateSelect from "@/components/TranslateSelect";

export default {
  name: "AppTemplate",
  components: {
    MobileMenu,
    TranslateSelect,
  },
  computed: {
    ...mapGetters("utils", ["urlLogin"]),
    ...mapState("apps", ["filters"]),
    ...mapState("category", ["categories"]),
    selectedCategoryId() {
      return this.filters.category_id;
    },
  },
  // mounted() {
  //   this.getCategories();
  // },
  methods: {
    // ...mapActions("apps", ["setFilterCategoryId"]),
    // ...mapActions("category", ["getCategories"]),
    // changeCategory(id) {
    //   this.setFilterCategoryId({ id: id });
    // }
  },
};
</script>

<style lang="scss">
.has-dropdown {
  &:hover {
    .dropdown {
      visibility: visible !important;
      opacity: 1 !important;
    }
  }
}

@media screen and (max-width: 768px) {
  .main-menu {
    display: none;
  }
}

.top-block-right {
  display: flex;
  justify-content: end;
}

.video-hero {
  // background-image: url(@/assets/images/cover_img_1.jpg);
  background-size: cover;
  background-position: center center;
  background-attachment: fixed;
  border-bottom: 1px solid #ccc;
  height: 150px !important;
  @media screen and (max-width: 769px) {
    height: 200px !important;
  }
}

.opacity-50 {
  opacity: 0.6;
}

.animate-box {
  h3 {
    font-size: 25px !important;
  }
  p {
    font-size: 1.1em !important;
    line-height: 1.4em !important;
  }
}

.mobile-wrap {
  @media screen and (max-width: 769px) {
    margin-bottom: 20px !important;
  }
}

.animate-box {
  @media screen and (max-width: 769px) {
    margin-top: 30px;
  }
}

.colorlib-work-featured {
  padding: 3em 0;
}

h2 {
  @media screen and (max-width: 769px) {
    font-size: 30px !important;
  }
}

// .display-tc {
//   height: 500px !important;
// }

.video-hero {
  .display-tc p {
    @media screen and (max-width: 769px) {
      font-size: 18px !important;
    }
  }
}

.slogan {
  font-size: 13.5px;
  font-weight: normal;
  margin-top: 5px;
  color: rgb(246, 246, 246);

  @media screen and (max-width: 500px) {
    text-align: center;
  }
}

#colorlib-logo {
  div {
    text-align: left;
    @media screen and (max-width: 500px) {
      text-align: center !important;
    }
    .logo-top {
      @media screen and (max-width: 500px) {
        margin: 0px auto;
      }
    }
  }
}

ul {
  margin-right: 20px;
}

li {
  text-decoration: none !important;
}

u {
  text-decoration: none;
}

.f-desc {
  font-size: 1.1em;
}

.colorlib-work-featured .mobile-wrap .desc h2 {
  font-size: 40px;
}

.page-title {
  text-align: center;
  margin-top: 50px;
  margin-bottom: 50px;
  color: #0f0f0f;
  font-size: 50px;
}

.colorlib-nav {
  top: 0px;
}

.colorlib-nav ul li {
  font-size: 13px !important;
}

#colorlib-footer {
  padding-top: 2em !important;

  .colorlib-footer-links {
    display: flex;
    flex-wrap: wrap;
    li {
      padding-right: 25px !important;
      padding-bottom: 10px !important;
      display: inline;
      font-size: 13px !important;
    }
  }
}
</style>